import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide14LiveDemo(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-blau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-120px",
          right: "-120px",
          background: "var(--svo-weiss)",
          opacity: 0.1,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-100px",
          left: "5%",
          background: "var(--svo-dunkelblau)",
          opacity: 0.3,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="deck-eyebrow rise rise-1" style={{ color: "rgba(255,255,255,0.9)" }}>
          Live-Demo
        </div>
      </header>

      <div className="deck-hero">
        <div className="hero-statement rise rise-2">
          Software, mit KI gebaut? <br />
          <span className="accent">So sieht das aus: SVO OS.</span>
        </div>
        <div
          className="rise rise-3"
          style={{
            display: "inline-flex",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            padding: "0.75rem 1.5rem",
            background: "rgba(255,255,255,0.12)",
            border: "1px solid rgba(255,255,255,0.25)",
            borderRadius: 999,
            fontSize: "clamp(1.2rem, 2.2vw, 1.85rem)",
            fontWeight: 500,
            color: "var(--svo-weiss)",
          }}
        >
          <span>SVO OS</span>
          <span style={{ opacity: 0.6 }}>·</span>
          <span>Live-Demo</span>
        </div>
        <div
          className="hero-sub rise rise-4"
          style={{ fontStyle: "italic", opacity: 0.7, fontSize: "clamp(0.95rem, 1.4vw, 1.1rem)" }}
        >
          [Wechsel zum Browser-Tab]
        </div>
      </div>
    </div>
  );
}
